import { CLASSES } from "@/scripts/helpers/constants";
import { handleParsleyActions } from "@/scripts/helpers/parsleyValidation";
import axios from "axios";

export default () => {
  const mails = [
    "gmail.com",
    "yahoo.com",
    "aol.com",
    "hotmail.com",
    "outlook.com",
    "icloud.com",
    "facebook.com",
    "me.com",
    "mac.com",
    "live.com",
    "comcast.com",
    "googlemail.com",
    "google.com",
    "msn.com",
    "hotmail.co.uk",
    "yahoo.co.uk",
    "verizon.net",
    "att.net",
    "gmz.com",
    "mail.com"
  ];

  const KEYS = {
    SPACE: 32,
    ARROWDOWN: 40,
    ARROWUP: 38,
    ENTER: 13
  };

  const input = document.querySelectorAll(".exp-18648");
  const suggestionsList = document.querySelectorAll(".email-suggestions-list");

  const removeElements = () => {
    const items = document.querySelectorAll(".email-suggestions-list__item");
    items.forEach(item => {
      item.remove();
    });

    suggestionsList.forEach(list => {
      list.classList.remove(CLASSES.IS_VISIBLE);
      list.classList.add(CLASSES.IS_HIDDEN);
    });
  };

  for (let i = 0; i < input.length; i++) {
    const displayNames = value => {
      input[i].value = value;
      removeElements();
    };

    input[i].addEventListener("keydown", e => {
      if (e.keyCode === KEYS.SPACE) {
        e.preventDefault();
        return false;
      }
    });

    input[i].addEventListener("keyup", e => {
      const hideError = () => {
        const parsley = input[i].nextElementSibling;

        if (parsley.classList.contains("parsley-errors-list")) parsley.remove();
      };
      const positionItemBottom =
        window.innerHeight -
        (input[i].getBoundingClientRect().top + input[i].offsetHeight);

      removeElements();
      hideError();

      for (let mail of mails) {
        if (
          mail.startsWith(input[i].value.split("@")[1]) &&
          input[i].value !== ""
        ) {
          const listItem = document.createElement("li");
          listItem.setAttribute("tabindex", mails.indexOf(mail) + 1);

          listItem.classList.add("email-suggestions-list__item");
          listItem.addEventListener("click", e => {
            displayNames(input[i].value.split("@")[0] + "@" + mail);
          });
          listItem.addEventListener("keypress", e => {
            if (e.keyCode === KEYS.ENTER) {
              displayNames(input[i].value.split("@")[0] + "@" + mail);
            }
          });
          let word = `${input[i].value.split("@")[0]}@${mail.substr(
            0,
            input[i].value.length
          )}`;
          word += mail.substr(input[i].value.length);
          listItem.innerHTML = word;

          const getListItems = Array.from(
            input[i].parentElement.children
          ).filter(chapter =>
            chapter.classList.contains("email-suggestions-list")
          );

          getListItems[0].appendChild(listItem);
          getListItems[0].classList.add(CLASSES.IS_VISIBLE);
          getListItems[0].classList.remove(CLASSES.IS_HIDDEN);

          if (positionItemBottom < 186) {
            getListItems[0].style.bottom = `${input[i].offsetHeight}px`;
          }
        }
      }
      if (e.keyCode === KEYS.ARROWDOWN) {
        $(".email-suggestions-list")
          .on("focus", "li", function() {
            $(this)
              .addClass(CLASSES.IS_ACTIVE)
              .closest(".email-suggestions-list")
              .removeClass(CLASSES.IS_ACTIVE);
          })
          .on("keydown", "li", function(e) {
            if (e.keyCode === KEYS.ARROWDOWN) {
              this.nextElementSibling.focus();
              input[i].value = this.nextElementSibling.innerText;
              return false;
            } else if (e.keyCode === KEYS.ARROWUP) {
              this.previousElementSibling.focus();
              input[i].value = this.previousElementSibling.innerText;
              return false;
            }
          })
          .find("li")
          .first()
          .focus();
      }
    });

    $(document).click(function(e) {
      if (e.target.nodeName !== "INPUT") {
        removeElements();
      }
    });
  }

  const onEmailSuggestionsSendEvents = () => {
    let clickEvents = {};

    $(".submit-event").on("submit", function(e) {
      const form = $(this);
      const submitEventType = form.attr("data-submit-event-type");
      const isParsleyInitialised = form.parsley !== undefined;

      if (clickEvents[submitEventType] === undefined) {
        if (
          (isParsleyInitialised && form.parsley().isValid()) ||
          !isParsleyInitialised
        ) {
          clickEvents[submitEventType] = true;

          axios.post("/event/click-events", {
            _token: $('meta[name="csrf-token"]').attr("content"),
            eventType: submitEventType
          });
        }
      }
    });
  };

  onEmailSuggestionsSendEvents();
};
